import * as ServiceProduct from '../services/products';
import i18n from '../translations'

export default {
    namespaced: true,
    actions: {
        async getProducts({ commit }) {
            let response = await ServiceProduct.getProducts();
            if (response.data) {
                let products = response.data.productCollection.allProducts.filter(function(product){
                    // console.log(product);
                    return true;
                    if(product.sku == 'U_TRS')
                        return true;
                    return product.price > 0;
                });
                commit('setProducts', products);
                commit('setProductsTotal', parseInt(products.length));
            } else {
                console.log(response)
            }
        },
        async getProductsToCardCode(context) {
            context.commit('productLoading', true);
            let cardCode = (context.rootState.customers.customer.cardCode) ? context.rootState.customers.customer.cardCode : "";
            let currency = (context.rootState.customers.customer.defaultCurrency) ? context.rootState.customers.customer.defaultCurrency : context.rootGetters['currency/currentCurrency'];
            if(currency === "##")
                currency = context.rootGetters['currency/currentCurrency'];
            let searchField = context.rootState.products.searchTerm;
            let userText = "";
            let pageSize = context.rootState.products.pageSize;
            let currentPage = context.rootState.products.currentPage;
            let countPage = "";
            // if (typeof cardCode != "undefined") {
                let response = await ServiceProduct.getProductsByCardCode(cardCode, searchField, userText, pageSize, currentPage, countPage,currency);
                context.commit('productLoading', false)
                if (response.data) {
                    //let products = response.data.productByFilterCollection.allProductFilterData.filter(product => product.price > 0);
                    let products = response.data.productByFilterCollection.allProductFilterData.filter(function(product){
                    
                        if(product.sku == 'U_TRS')
                            return true;
                        return product.price >= 0;
                    });
                    let producstLength = response.data.productByFilterCollection.allInformationFilter[0].counter;
                    context.commit('setProducts', products);
                    context.commit('setProductsTotal', parseInt(producstLength))
                } else {
                    console.log(response)
                }
            // }
        }
    },
    state: {
        products: [],
        productsTotal: 0,
        currentPage: 1,
        pageSize: 12,
        searchTerm: '',
        productLoading: false
    },
    getters: {
        filteredProducts: state => {
            let loweredTerm = state.searchTerm.toLowerCase()
            let regex = new RegExp(loweredTerm.split(' ').join('.*'))
            if (state.searchTerm) {
                return state.products.filter(product => {
                    let translate = i18n.locale;
                    if (translate === 'pl') {
                        return regex.test(product.name.toLowerCase()) || String(product.sku).toLowerCase().includes(loweredTerm) || String(product.userText).toLowerCase().includes(loweredTerm);
                    } else {
                        return regex.test(product.descriptionEn.toLowerCase()) || String(product.sku).toLowerCase().includes(loweredTerm) || String(product.userText).toLowerCase().includes(loweredTerm);;
                    }
                })
            } else {
                return state.products
            }
        },
        processedProducts: (state, getters, context) => {
            // let index = (state.currentPage - 1) * state.pageSize;
            return getters.filteredProducts.slice(0, 0 + state.pageSize);
        },
        processedProductsTotal: (state, getters) => {
            return state.productsTotal;
        },
        pageCount: (state, getters) => {
            return Math.ceil(getters.processedProductsTotal / state.pageSize)
        },

        productLoading: (state, getters) => {
            return state.productLoading;
        },
        itemCount: state =>
            state.order.lines.reduce((total, line) => total + line.quantity, 0),
        totalPrice: state =>
            state.order.lines.reduce(
                (total, line) => total + line.quantity * line.product.price,
                0
            ),
    },
    mutations: {
        productLoading(state, newLoading) {
            state.productLoading = newLoading;
        },
        setSearchTerm(state, term) {
            state.searchTerm = term;
            state.currentPage = 1;
            this.dispatch('products/getProductsToCardCode');
        },
        setProductsTotal(state, productsNumber) {
            state.productsTotal = productsNumber;
        },
        setProducts(state, products) {
            state.products = products;
        },
        setCurrentPage(state, page) {
            state.currentPage = page;
            this.dispatch('products/getProductsToCardCode');
        },
        setPageSize(state, size) {
            state.pageSize = size;
            state.currentPage = 1;
            this.dispatch('products/getProductsToCardCode');
        },
        changeQuantity(state, update) {
            update.line.quantity = update.quantity;
        },
    },
};
